module.exports = __webpack_public_path__ + "img/spot-orange-8.png";